import { Query, QueryUpdaterCallback } from '@shared/api/types';
import { Pagination } from '@shared/ui/components/Pagination';
import { Select } from '@shared/ui/components/Select';

type DataTableFooterProps = {
  results: number;
  pages: number;
  avoidPagination: boolean;
  query: Query;
  onQueryChange: QueryUpdaterCallback;
};

const pageOptions = [5, 10, 20, 50, 100].map((pages) => ({ label: pages, value: pages }));

export function DataTableFooter({ results, pages, avoidPagination, query, onQueryChange }: DataTableFooterProps) {
  if (avoidPagination && pages < 2) {
    return null;
  }

  return (
    <div className="mt-8 flex items-center flex-wrap gap-3 justify-center sm:justify-between text-sm">
      <div className="flex items-center gap-6">
        <div className="pr-6 border-r">
          Showing {results > 0 ? (query.page.number - 1) * query.page.size + 1 : 0} to{' '}
          {Math.min(query.page.number * query.page.size, results)} of <span className="font-semibold">{results}</span>
        </div>
        <div className="flex items-center gap-2">
          <Select
            options={pageOptions}
            value={query.page.size}
            onChange={(pageSize) =>
              onQueryChange((query) => (pageSize ? { ...query, page: { ...query.page, size: pageSize } } : query))
            }
            className="w-[8ch]"
          />
          per page
        </div>
      </div>
      <Pagination
        page={query.page.number}
        pages={pages}
        onChange={(page) => onQueryChange((query) => ({ ...query, page: { ...query.page, number: page } }))}
      />
    </div>
  );
}
